<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">Nettoyage en masse des colis</div>
            <div class="dialog-content">
                <p>Les colis ayant ce statut ne seront plus déplacés dans les tournées suivantes et resteront donc dans leur état actuel.</p>
                <v-row align="center">
                    <v-col
                        class="d-flex"
                        cols="12"
                    >
                        <v-select
                            v-model="selectedItem"
                            :items="items"
                            outlined
                            label="Statut des colis à nettoyer"
                            :error="!!selectedItemError"
                            :error-messages="selectedItemError"
                            @change="selectedItemError = null"
                        ></v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                    >
                        <v-checkbox
                            v-model="deleteNextItems"
                            label="Nettoyer les colis suivants"
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </div>
            <div class="dialog-footer d-flex">
                <v-btn elevation="0"
                       @click="showDialog = false">
                    {{ $t("global.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" elevation="0"
                       @click="validate">
                    {{ $t("global.validate") }}
                </v-btn>
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
import i18n from "../../plugins/i18n";

export default {
    name: "Administration",
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        message: {
            type: String,
            required: false,
            default: function () {
                return i18n.t("global.going_to_delete")
            }
        }
    },
    data () {
        return {
            items: [
                {
                    text: "Tous les colis",
                    value: "all"
                },
                {
                    text: "Colis en anomalie bloquantes",
                    value: "anomaly"
                },
                {
                    text: "Clients en défaut de paiement",
                    value: "payment"
                },
                {
                    text: "Colis avec une quantité manquante",
                    value: "missing"
                },
                {
                    text: "Colis non livrés",
                    value: "undelivered"
                }
            ],
            selectedItem: null,
            selectedItemError: null,
            deleteNextItems: false
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        validate() {
            if (!this.selectedItem) {
                this.selectedItemError = "Veuillez sélectionner un statut";
                return;
            }
            this.$emit('validate', this.selectedItem, this.deleteNextItems)
        },
    },
}
</script>
